import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { get } from 'lodash-es';
import { CustomFieldViewComponent, Form, ViewCustomFieldSettings } from '../../../../base/form';
import { CUSTOM_FIELD_VIEW_SELECTORS } from './config';
import { LooseObject } from '../../../../objects/loose-object';
import { filled } from '../../../utils/common';
import { ViewService } from '../../../../services/view.service';

@Component({
  selector: 'fieldmagic-custom-view-field',
  template: `
    <ng-container #container></ng-container>
  `
})
export class ViewCustomFieldComponent implements OnInit {
  /**
   * The field data
   */
  @Input('field') field: Form<unknown>

  @Input() settings: ViewCustomFieldSettings = {};

  /**
   * Contains the additional data you may want to pass to your custom field.
   *
   * @type {LooseObject}
   */
  @Input('additionalData') additionalData: LooseObject

  /**
   * The template reference that will be replaced by the custom component to be display
   */
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

  /**
   * Create instance of the component that is responsible for rendering the custom template component
   * for the current custom field
   */
  constructor(
    private readonly _cfr: ComponentFactoryResolver,
    private readonly _view: ViewService,
  ) {}

  ngOnInit(): void {
    const ref = this.container.createComponent<CustomFieldViewComponent>(this._cfr.resolveComponentFactory(
      get(CUSTOM_FIELD_VIEW_SELECTORS, this.field.custom_form_options.component_selector)
    ));

    ref.instance.setField(this.field);

    if (filled(this.additionalData) && 'setAdditionalData' in ref.instance) {
      ref.instance.setAdditionalData(this.additionalData);
    }

    if ('setViewData' in ref.instance) {
      ref.instance.setViewData(this._view.arRecord);
    }

    const settings: ViewCustomFieldSettings = Object.assign({
      viewed_as_dialog: false,
    }, this.settings);

    if ('setSettings' in ref.instance) {
      ref.instance.setSettings(settings);
    }
  }
}